import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PackageIcon, TagIcon, ExternalLinkIcon, TrendingUpIcon } from 'lucide-react';
interface BrandQuickActionsProps {
  brandSlug: string;
  brandName: string;
}
export function BrandQuickActions({
  brandSlug,
  brandName
}: BrandQuickActionsProps) {
  const navigate = useNavigate();
  const actions = [{
    id: 1,
    title: 'View All Products',
    description: 'Browse our complete collection',
    icon: <PackageIcon className="w-8 h-8" data-id="element-1328" data-mp="1q795uszobe96" />,
    color: 'from-blue-500 to-blue-600',
    action: () => navigate(`/category/${brandSlug}`),
    count: '150+ Products'
  }, {
    id: 2,
    title: 'View All Offers',
    description: 'Exclusive deals and discounts',
    icon: <TagIcon className="w-8 h-8" data-id="element-1329" data-mp="2032ei1a9unlo" />,
    color: 'from-red-500 to-red-600',
    action: () => navigate(`/offers?brand=${brandSlug}`),
    count: 'Up to 40% OFF'
  }, {
    id: 3,
    title: 'Best Sellers',
    description: 'Most popular products',
    icon: <TrendingUpIcon className="w-8 h-8" data-id="element-1330" data-mp="2545uev5mzngr" />,
    color: 'from-purple-500 to-purple-600',
    action: () => navigate(`/category/${brandSlug}?sort=best-sellers`),
    count: 'Top Rated'
  }, {
    id: 4,
    title: 'Visit Official Website',
    description: 'Learn more about the brand',
    icon: <ExternalLinkIcon className="w-8 h-8" data-id="element-1331" data-mp="1r70p4xdqysmk" />,
    color: 'from-sage to-sage-dark',
    action: () => window.open('https://www.vichy.com', '_blank'),
    count: 'External Link'
  }];
  return <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1332" data-mp="1hd0e6evsat5x">
      <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-1333" data-mp="1dekqs9vsjirz">
        {actions.map(action => <button key={action.id} onClick={action.action} className="group relative bg-white rounded-xl shadow-sm hover:shadow-xl transition-all overflow-hidden border border-gray-100 min-h-[44px]" data-id="element-1334" data-mp="18fzu2kfqzh8a">
            <div className={`absolute inset-0 bg-gradient-to-br ${action.color} opacity-0 group-hover:opacity-10 transition-opacity`} data-id="element-1335" data-mp="oswlqyc2lq2t"></div>
            <div className="relative p-4 md:p-6" data-id="element-1336" data-mp="tpmzvg4bebll">
              <div className={`bg-gradient-to-br ${action.color} text-white p-3 md:p-4 rounded-xl mb-3 md:mb-4 inline-flex`} data-id="element-1337" data-mp="fsqc5njhta8x">
                {action.icon}
              </div>
              <h3 className="font-bold text-gray-900 mb-1 md:mb-2 text-sm md:text-lg" data-id="element-1338" data-mp="17k5v97luceue">
                {action.title}
              </h3>
              <p className="text-xs md:text-sm text-gray-600 mb-2 md:mb-3" data-id="element-1339" data-mp="1chfwdkileey2">
                {action.description}
              </p>
              <div className="inline-flex items-center text-xs md:text-sm font-semibold text-[#1E2B55]" data-id="element-1340" data-mp="12s615vsgcg5q">
                {action.count}
                <svg className="w-3 h-3 md:w-4 md:h-4 ml-1 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-1341" data-mp="1qgxjzwk5jm5u">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" data-id="element-1342" data-mp="3b01429hxd7hr" />
                </svg>
              </div>
            </div>
          </button>)}
      </div>
    </div>;
}